import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fmtId } from '../util/format';
import Modal from './Modal';

/* Inrichting toevoegen — eerst de vraag welk soort recht.

   "Inrichting toevoegen" is wat de behandelaar doet, dus zo heet de knop ook.
   Maar een melding en een vergunning zijn twee verschillende dingen met twee
   verschillende formulieren, en die keuze hoort vóór het formulier te vallen,
   niet als radioknop halverwege.

   Op dit moment weet de pagina al welke inrichtingen deze houder heeft, dus
   hier zit meteen de bewaking:

     melding      een houder kan er maar één hebben. Bestaat hij al, dan maken
                  we geen tweede maar gaan we naar díe inrichting; een nieuwe
                  melding vervangt daar het gebruiksrecht.
     vergunning   een houder kán er meer hebben (twee locaties bijvoorbeeld).
                  We waarschuwen, maar staan het toe.

   Een inrichting waarvan het recht pas later ingaat telt mee als bestaand: er
   is een dossier, en een tweede ernaast zou een dubbele registratie zijn. Een
   beëindigde inrichting telt niet mee. */

function bestaande(inrichtingen, rechtstype) {
  return (inrichtingen || []).filter(
    (i) => !i.einddatum && i.rechtstype === rechtstype
  );
}

function noem(i) {
  const kenmerk = i.verzoeknummer || i.gebruiksrecht_kenmerk;
  return `${fmtId(i.inrichting_id)}${kenmerk ? ` (${kenmerk})` : ''}`;
}

export default function InrichtingToevoegenModal({ isOpen, onClose, houderId, houderNaam, inrichtingen }) {
  const navigate = useNavigate();
  const [stap, setStap] = useState('keuze');

  const meldingen = bestaande(inrichtingen, 'melding');
  const vergunningen = bestaande(inrichtingen, 'vergunning');
  const naam = houderNaam || 'Deze houder';

  const sluit = () => { setStap('keuze'); onClose(); };

  const kiesMelding = () => {
    if (meldingen.length > 0) { setStap('melding-bestaat'); return; }
    navigate(`/beregening/houders/${houderId}/melding-verwerken`);
  };
  const kiesVergunning = () => {
    if (vergunningen.length > 0) { setStap('vergunning-bestaat'); return; }
    navigate(`/beregening/houders/${houderId}/vergunning-nieuw`);
  };

  const titel = stap === 'keuze' ? 'Inrichting toevoegen'
    : stap === 'melding-bestaat' ? 'Er is al een melding-inrichting'
      : 'Er is al een vergunning-inrichting';

  return (
    <Modal isOpen={isOpen} onClose={sluit} title={titel} maxWidth={stap === 'vergunning-bestaat' ? 760 : 640}>
      {stap === 'keuze' && (
        <>
          <p className="mf-start-vraag">Waar gaat het om?</p>
          <div className="mf-start-keuzes">
            <button className="mf-start-kaart" onClick={kiesMelding}>
              <span className="mf-start-titel">Melding verwerken</span>
              <span className="mf-start-sub">
                Een melding van agrarische beregening, via de bijlage van het
                meldingsformulier of handmatig.
              </span>
            </button>
            <button className="mf-start-kaart" onClick={kiesVergunning}>
              <span className="mf-start-titel">Vergunning aanmaken</span>
              <span className="mf-start-sub">
                Een vergunde onttrekking, met doelen en vergund debiet.
              </span>
            </button>
          </div>
        </>
      )}

      {stap === 'melding-bestaat' && (
        <>
          <p style={{ margin: '0 0 20px', fontSize: 14.5, color: 'var(--text-soft)', lineHeight: 1.6 }}>
            {naam} heeft al een inrichting op basis van een melding:{' '}
            <strong>{meldingen.map(noem).join(', ')}</strong>. Een nieuwe melding
            vervangt dat gebruiksrecht — de huidige staat gaat naar de historie.
            Je gaat verder op deze inrichting.
          </p>
          <div className="row" style={{ justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn btn-ghost" onClick={sluit}>Annuleren</button>
            <button
              className="btn btn-primary"
              onClick={() => navigate(
                `/beregening/inrichtingen/${meldingen[0].inrichting_id}/melding-verwerken`
              )}
            >
              Melding verwerken
            </button>
          </div>
        </>
      )}

      {stap === 'vergunning-bestaat' && (
        <>
          <p style={{ margin: '0 0 20px', fontSize: 14.5, color: 'var(--text-soft)', lineHeight: 1.6 }}>
            Let op: {naam} heeft al een inrichting op basis van een vergunning:{' '}
            <strong>{vergunningen.map(noem).join(', ')}</strong>. Gaat het om een
            wijziging van díe vergunning, verwerk het dan als wijzigingsbesluit.
            Maak alleen een tweede vergunning-inrichting aan als het echt om een
            andere inrichting gaat, bijvoorbeeld een tweede locatie.
          </p>
          {/* Annuleren links, de twee wegen rechts; anders vallen ze op een
              smal scherm uit elkaar en lijkt de laatste knop de enige. */}
          <div className="row" style={{ justifyContent: 'space-between', gap: 8 }}>
            <button className="btn btn-ghost" onClick={sluit}>Annuleren</button>
            <div className="row" style={{ gap: 8 }}>
              <button
                className="btn btn-secondary"
                onClick={() => navigate(`/beregening/houders/${houderId}/vergunning-nieuw`)}
              >
                Toch een nieuwe
              </button>
              <button
                className="btn btn-primary"
                onClick={() => navigate(
                  `/beregening/inrichtingen/${vergunningen[0].inrichting_id}?wijzigingsbesluit=1`
                )}
              >
                Wijzigingsbesluit op {fmtId(vergunningen[0].inrichting_id)}
              </button>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
}
